import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
	initGoogleAnalytics,
	isGoogleAnalyticsEnabled,
	trackPageView,
} from '../../utils/googleAnalytics';

const GoogleAnalyticsTracker = () => {
	const location = useLocation();

	useEffect(() => {
		if (isGoogleAnalyticsEnabled()) {
			initGoogleAnalytics();
		}
	}, []);

	useEffect(() => {
		if (!isGoogleAnalyticsEnabled()) return;

		const path = `${location.pathname}${location.search}${location.hash}`;
		trackPageView(path);
	}, [location.pathname, location.search, location.hash]);

	return null;
};

export default GoogleAnalyticsTracker;
